import SearchBar from './Searchbar';
import Selector from './Selector';
import ClipLoader from 'react-spinners/ClipLoader';
import { useTranslation } from 'react-i18next';

const DynamicTable = ({
  data = [],
  customColumnsMap = [],
  searchTerm = '',
  onSearchChange = () => {},
  filterOptions = null, // { key, options: [{ value, label }] }
  filterValue = 'Tutti',
  onFilterChange = () => {},
  selectedRows = [],
  onToggleRow = () => {},
  onToggleAll = () => {},
  enableRowSelection = false,
  showSearchBar = false,
  maxHeight = null,
  deleting = false,
  deleteSelected = () => {}
}) => {

  const isRowSelected = (row) => selectedRows.includes(row);
  const allVisibleRowsSelected = data.every(row => isRowSelected(row));
  const { t } = useTranslation();

  return (
    <div className="max-w-7xl">
      {/* translation */}
      {/**/}
      {/**/}
      
      {/* i18n */}
      
      
      
      {(showSearchBar || filterOptions) && (
        <div className="mb-4 flex flex-col sm:flex-row justify-between gap-4">
          <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
            {showSearchBar && (
              <SearchBar
                search={searchTerm}
                setSearch={onSearchChange}
                placeholder={t('table.searchPlaceholder')}
              />
            )}
            {filterOptions && (
              <Selector
                value={filterValue}
                onChange={onFilterChange}
                options={filterOptions.options}
                width={'w-full sm:w-72'}
              />
            )}
          </div>
          
        {selectedRows.length > 0 && (
          <div className="animate-fadeIn">
            <button
              onClick={deleteSelected}
              disabled={deleting}
              className={`
                relative flex items-center justify-center
                px-4 py-2 bg-red-500 text-white rounded
                hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed
              `}
            >
              {deleting && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <ClipLoader size={16} color="#fff" />
                </div>
              )}
              <span className={deleting ? 'invisible' : ''}>
                {t('table.deleteSelected', { count: selectedRows.length })}
              </span>
            </button>
          </div>
        )}
        </div>
      )}

      <div className="border border-gray-200 rounded-md overflow-hidden max-w-full">
        <div className="overflow-x-auto -mx-0">
          <div style={maxHeight ? { maxHeight, overflowY: 'auto' } : {}}>
            <table className="min-w-full table-auto bg-white">
              <thead className="bg-gray-200 sticky top-0 z-10">
                <tr>
                  {enableRowSelection && (
                    <th className="w-10 px-2 text-center">
                      <input
                        type="checkbox"
                        checked={allVisibleRowsSelected}
                        onChange={onToggleAll}
                      />
                    </th>
                  )}
                  {customColumnsMap.map((col, idx) => (
                    <th
                      key={idx}
                      className={`px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider
                        whitespace-nowrap overflow-hidden ${col.width ?? 'w-40'}
                        ${col.align === 'right' ? 'text-right' : col.align === 'center' ? 'text-center' : 'text-left'}`}
                    >
                      <div className={`flex items-center gap-1 ${col.align === 'right' ? 'justify-end' : col.align === 'center' ? 'justify-center' : 'justify-start'}`}>
                        {col.label ?? ''}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {data.length === 0 ? (
                  <tr>
                    <td
                      colSpan={customColumnsMap.length + (enableRowSelection ? 1 : 0)}
                      className="px-4 py-6 text-center text-gray-400 text-sm"
                    >
                      {t('table.noResults')}
                    </td>
                  </tr>
                ) : (
                  data.map((row, rowIndex) => (
                    <tr key={rowIndex} className="hover:bg-gray-50">
                      {enableRowSelection && (
                        <td className="px-2 py-2 text-center w-10">
                          <input
                          className='cursor-pointer'
                            type="checkbox"
                            checked={isRowSelected(row)}
                            onChange={() => onToggleRow(row)}
                          />
                        </td>
                      )}
                      {customColumnsMap.map((col, colIndex) => (
                        <td
                          key={colIndex}
                          className={`px-4 py-4 text-sm whitespace-nowrap overflow-hidden truncate ${col.width ?? 'w-40'}
                            ${col.align === 'right' ? 'text-right' : col.align === 'center' ? 'text-center' : 'text-left'}
                            ${colIndex === 0 ? 'font-medium text-gray-900' : 'text-gray-600'}`}
                        >
                          {col.render
                            ? col.render(row, rowIndex)
                            : String(row[col.field] ?? '')}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DynamicTable;